function stripWrappersWithMap(text) {
  const map = new Array(text.length + 1);
  let out = "";
  let i = 0;

  while(i < text.length) {
    map[i] = out.length;

    const two = text.slice(i, i + 2);
    if(two === "{{" || two === "}}") {
      // Map the second brace too, so a selection edge landing between the
      // braces still resolves to an offset in the stripped text.
      map[i + 1] = out.length;
      i += 2;
      continue;
    }

    out += text[i];
    i += 1;
  }

  map[text.length] = out.length;
  return { stripped: out, map };
}

export default function wrapSelectionEnsureSingle(text, selStart, selEnd) {
  const { stripped, map } = stripWrappersWithMap(text);

  const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
  const a = clamp(selStart == null ? 0 : selStart, 0, text.length);
  const b = clamp(selEnd == null ? 0 : selEnd, 0, text.length);

  let start = map[a];
  let end = map[b];
  if(start > end) [start, end] = [end, start];

  if(start === end) {
    return { nextText: stripped, nextSelection: { start, end } };
  }

  const nextText =
    stripped.slice(0, start) + "{{" + stripped.slice(start, end) + "}}" + stripped.slice(end);

  const nextSelection = { start: start + 2, end: end + 2 };

  return { nextText, nextSelection };
}
